<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-bodymatter element-type-chapter element-with-heading" id="vol-1-chapter-11">
<div class="heading heading-with-title heading-without-image" id="vol-1-chapter-11-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Chapter 11</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-chapter-11-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">J</span>osh and I fall out of the fourth bar of the night and zig-zag our way along the Promenade. His friends have long since gone. They got bored of taking the piss and were last seen disappearing into a dodgy-looking club, chasing a hen party. Pete was leading the charge and still performing like a dick.</p>
<p class="subsq">I have my arm wrapped tightly around his waist to keep him upright. His arm is draped across my shoulders more for balance than in a show of affection. His body feels cold as the night sea air chills his skin through his shirt. I feel my own skin prickle with goosebumps, not a reaction to the cold, but in anticipation. I’m trying hard to keep my excitement under control. Josh is so beautiful.</p>
<p class="subsq">‘Where are weees going?’ he slurs.</p>
<p class="subsq">‘Back to my place.’</p>
<p class="subsq">‘Thaas fuckin’ brilliant.’ He squeezes me into him and we teeter around falling off the kerb.</p>
<p class="subsq">Josh proved to have a remarkable tolerance to alcohol, taking two drinks to my one. He alternated between wine and beer, wine on my round and beer on his. I needed to keep a reign on my natural tendency to match him drink for drink, after all it would be no use if both of us were incapable.</p>
<p class="subsq">He veers off to one side and sits down hard on a low wall outside a hotel guest house. The momentum pulls me with him.</p>
<p class="subsq">‘Where are weees going?’</p>
<p class="subsq">‘Back to my place.’ I lean in and plant a kiss on his cheek. He turns his head and our lips touch. I feel the wet warmth of his tongue as it darts into my mouth. The kiss lingers for a lifetime.</p>
<p class="subsq">He even tastes beautiful. My heart is thumping.</p>
<p class="subsq">‘Thaas fuckin’ brilliant,’ he says as we pull away. I take his arm and pull him upright, once more gripping him tight.</p>
<p class="subsq">‘It’s not far, a few more minutes.’</p>
<p class="subsq">The tranquillising effect of the Rohypnol is taking its toll. The crushed white powder has been coursing through his system since I got the drinks at the last bar and he went to the gents. A large glass of dry white wine makes an ideal dissolving agent. The effects started to kick in after thirty minutes. I look at my watch. It’s now been an hour since it first entered his system. He’ll soon be approaching the peak and I need to get him to the right place before he collapses.</p>
<p class="subsq">He is getting heavy and difficult to manoeuvre along the pavement. My heart thumps hard against my chest.</p>
<p class="subsq">‘It’s here,’ I say. ‘Down this alleyway.’</p>
<p class="subsq">‘Doooes you live here?’</p>
<p class="subsq">‘Yes, I have a small flat in the building at the end.’</p>
<p class="subsq">‘Thass fuckin’ brilliant.’</p>
<p class="subsq">I guide him away to the right and we lurch into the gap between two high-rise brick buildings. The alley is about ten feet wide and the night sky disappears into a thin slit at the top as we make our way along. It stinks of piss.</p>
<p class="subsq">‘I live at the end.’ My voice trembles with excitement.</p>
<p class="subsq">We bounce off the left-hand wall, staggering up the alley, kicking cans and bottles as we go. The orange glow from the street lighting fades away against the deepening darkness. After twenty faltering steps, we reach a dead end. I feel his legs give way and he stumbles forward, landing on his knees.</p>
<p class="subsq">‘It’s fuckin’ dark,’ he says.</p>
<p class="subsq">‘Wait here, Josh and I’ll open the door.’</p>
<p class="subsq">‘Wheers the fucks are wez?’ His words are melding into one.</p>
<p class="subsq">‘My place Josh, let me get my keys and open the door.’ I lean forward cradling his face in my hands and kiss his forehead. He is totally gorgeous.</p>
<p class="subsq">‘I caaan’t see mush, wheres yous gone?’</p>
<p class="subsq">‘Just getting my keys, Josh,’ I say, stepping to one side.</p>
<p class="subsq">‘Can we have a little kiss?’</p>
<p class="subsq">‘In a minute Josh, just finding my keys.’</p>
<p class="subsq">‘Can wees—’</p>
<p class="subsq">The sound of his skull cracking resonates against the high walls as I slam the hammer into the side of his head. Josh keels over sideways without uttering a sound. The next blow follows quickly, connecting with a squelch on the back of his neck. His face skids into the concrete, he’s dead before he hits the ground. I look down, allowing my eyes to adjust to the darkness. The outline of his body lies white against the grey slab paving, a dark stain growing around his head.</p>
<p class="subsq"><i>And one for luck …</i></p>
<p class="subsq">The lump hammer punches a square hole in the side of his head where his temple used to be.</p>
<p class="subsq"><i>That will teach you to take your wedding ring off. You won’t do that again.</i></p>
<p class="subsq"><i>I love being on Parade.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001chapter011.vue?1719921a